'use strict';

import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SubjectsStorage } from '../../subjects/subjects-storage';
import {Observable, of} from 'rxjs';
import {Subject} from '../../subjects/subject';
import { findSelectedSite } from '../../shared/route-helpers';

@Injectable()
export class SubjectsListResolver implements Resolve<Observable<Subject[]>> {

    constructor(private subjectsStorage: SubjectsStorage) { }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Subject[]> {
        const site = findSelectedSite(route);

        return this.subjectsStorage.getSubjects(of(site));
    }
}